import { useEffect, useRef, useState } from 'react';

// const INACTIVITY_LIMIT = 60 * 60 * 1000; // 1 hour
// const SESSION_DURATION = 10 * 60 * 1000; // 60 minutes
const INACTIVITY_LIMIT = (parseInt(process.env.REACT_APP_INACTIVITY_LIMIT) || 10) * 60 * 1000; // 10 minutes
const SESSION_DURATION = (parseInt(process.env.REACT_APP_SESSION_DURATION) || 25) * 60 * 1000; // 25 minutes
const CHECK_INTERVAL = 5 * 60 * 1000; // every 5 mins

const LAST_ACTIVITY_KEY = 'lastActivityTime';
const SESSION_EXPIRES_AT_KEY = 'sessionExpiresAt';

const useAutoLogout = (logoutFn, token, navigate, dispatch) => {
  const intervalRef = useRef(null);

  const logoutUser = () => {
    const lastActivity = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY), 10);
    localStorage.removeItem(LAST_ACTIVITY_KEY);
    localStorage.removeItem(SESSION_EXPIRES_AT_KEY);
    logoutFn(token, navigate, dispatch, true);
  };

  const updateLastActivity = () => {
    const now = Date.now();
    localStorage.setItem(LAST_ACTIVITY_KEY, now.toString());
    localStorage.setItem(SESSION_EXPIRES_AT_KEY, (now + SESSION_DURATION).toString());
  };

  const checkInactivity = () => {
    const lastActivity = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY), 10);
    const sessionExpiresAt = parseInt(localStorage.getItem(SESSION_EXPIRES_AT_KEY), 10);
    const now = Date.now();

    if (sessionExpiresAt && now >= sessionExpiresAt) {
      logoutUser(); // Session expired
      return;
    }

    if (lastActivity && now - lastActivity >= INACTIVITY_LIMIT) {
      logoutUser(); // Inactivity logout
    }
  };

  useEffect(() => {
    // Initial check for session expiry
    const sessionExpiresAt = parseInt(localStorage.getItem(SESSION_EXPIRES_AT_KEY), 10);
    const now = Date.now();
    if (sessionExpiresAt && now >= sessionExpiresAt) {
      logoutUser();
    } else {
      updateLastActivity();
    }

    // Listen for user activity events
    const handleActivity = () => updateLastActivity();
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    events.forEach(event => window.addEventListener(event, handleActivity));

    // Listen for activity updates from other tabs
    const handleStorage = (e) => {
      if (e.key === LAST_ACTIVITY_KEY || e.key === SESSION_EXPIRES_AT_KEY) {
        checkInactivity();
      }
    };
    window.addEventListener('storage', handleStorage);

    // Start the interval to check for inactivity and session expiry
    intervalRef.current = setInterval(checkInactivity, CHECK_INTERVAL);

    return () => {
      events.forEach(event => window.removeEventListener(event, handleActivity));
      window.removeEventListener('storage', handleStorage);
      clearInterval(intervalRef.current);
    };
  }, [logoutFn, token, navigate, dispatch]);
};

export default useAutoLogout;